import { PackageSection } from './packages'
import { AssetFluid } from './asset'
import {
  HeroTextSection,
  HeroTextTwoColumnSection,
  HideOn,
} from './heroTextSection'
import { ImageInsert } from './post'
import { ProductPackageSection } from './productPageV2'

export interface Carousel {
  __typename: 'ContentfulCarousel'
  contentful_id: string
  name: string
  title: string
  breadcrumbs: 'Center' | 'Left' | 'None' | null
  arrows: 'None' | 'Show' | null
  images: AssetFluid[] | null
  slides: Slide[]
  variant: CarouselVariants
  noOfSlides: number
  hideOn: HideOn
}

export enum CarouselVariants {
  Single = 'Single',
  Half = 'Half Screen',
  Multiple = 'Multiple',
}

export type Slide =
  | PackageSection
  | ProductPackageSection
  | HeroTextSection
  | ImageInsert
  | HeroTextTwoColumnSection
  | {
      __typename: 'SimpleSlide'
      contentful_id: string
      body: string
      name: string
    }
